import { TestId as _TestId, TestClass as _TestClass } from './src/testIds';

export type TestId = _TestId;
export type TestClass = _TestClass;

export {
  HeaderTestIds,
  CreateBoardTestIds,
  HomeTestIds,
  NavigationTestIds,
  NotificationTestIds,
  PowerUpTestIds,
  TeamTestIds,
  CreateFirstBoardIds,
  PopoverTestIds,
  BillingIds,
  PurchaseFormIds,
  MoonshotTestIds,
  SlackCodesTestIds,
  CardBackTestIds,
  BoardHeaderTestIds,
  EnterpriseDashboardTestIds,
  OrganizationViewTestIds,
  SelectTestIds,
  FreeTrialTestIds,
  ChecklistTestIds,
  ProfileTestIds,
  WorkSpacesPreambleTestIds,
  BCTeamOnboardingTestIds,
  UpgradePromptTestIds,
  BadgesTestIds,
  CanonicalCard,
  BoardReportsViewTestIds,
  TEST_ID_ATTR,
  TEST_ID_SELECTOR,
  FreeTeamOnboardingTestIds,
  TableTestIds,
  CalendarViewTestIds,
  TimelineTestIds,
  WorkspaceNavigationTestIds,
  WorkspaceSwitcherTestIds,
  RecentlyViewedBoardsMenuTestIds,
  MigrationWizardTestIds,
  ViewHeaderTestIds,
  DateRangePickerTestIds,
  CardTemplateTestIds,
  TemplatesTestIds,
  ShortcutsPageTestIds,
  TeamTestClasses,
  TableTestClasses,
  PluginHeaderButtonTestIds,
  SelectTestClasses,
  MemberBoardsTestIds,
} from './src/testIds';
